/**
 * Properties reducer.
 * @module reducers/toolbar/toolbar
 */

import { POST_CONTACT_INFO } from '../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
};

/**
 * Site Properties reducer.
 * @function site
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function contact_info_email_send(
  state = initialState,
  action = {},
) {
  switch (action.type) {
    case `${POST_CONTACT_INFO}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
      };
    case `${POST_CONTACT_INFO}_SUCCESS`:
      if (action.result?.error) {
        return {
          ...state,
          error: action.result.error,
          loaded: false,
          loading: false,
        };
      }
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
      };
    case `${POST_CONTACT_INFO}_FAIL`:
      return {
        ...state,
        error: action.error.response.body.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
